import PropTypes from 'prop-types';
const TripSegmentName = ({
  tagName,
  stationClassName,
  departure,
  arrival,
  ...otherProps
}) => React.createElement(tagName, otherProps, [/*#__PURE__*/React.createElement("span", {
  key: "departure",
  className: stationClassName
}, departure.name), /*#__PURE__*/React.createElement("span", {
  key: "icon"
}, /*#__PURE__*/React.createElement("i", {
  className: "icon icon-right-arrow-medium ticket__inner-place__title"
})), /*#__PURE__*/React.createElement("span", {
  key: "arrival",
  className: stationClassName
}, arrival.name)]);
TripSegmentName.propTypes = {
  tagName: PropTypes.string,
  stationClassName: PropTypes.string,
  departure: PropTypes.object.isRequired,
  arrival: PropTypes.object.isRequired
};
TripSegmentName.defaultProps = {
  tagName: 'div'
};
export default TripSegmentName;